"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NumberFilter = void 0;
exports.findMax = findMax;
exports.findMin = findMin;
exports.onNumberFilter = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _FooterFilter = _interopRequireDefault(require("./FooterFilter"));
var _Button = _interopRequireDefault(require("../../../Button"));
var _NumberInput = _interopRequireDefault(require("../../../NumberInput"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function findMax(data, dataIndex) {
  if (!data) return 0;
  var max = Number.MIN_VALUE;
  for (var i = 0; i < data.length; i++) {
    if (data[i][dataIndex] > max) {
      max = data[i][dataIndex];
    }
  }
  return max;
}
function findMin(data, dataIndex) {
  if (!data) return 0;
  var min = Number.MAX_VALUE;
  for (var i = 0; i < data.length; i++) {
    if (data[i][dataIndex] < min) {
      min = data[i][dataIndex];
    }
  }
  return min;
}
var NumberFilter = exports.NumberFilter = /*#__PURE__*/function (_Component) {
  function NumberFilter(props) {
    var _this;
    (0, _classCallCheck2.default)(this, NumberFilter);
    _this = _callSuper(this, NumberFilter, [props]);
    (0, _defineProperty2.default)(_this, "onMinChange", function (value) {
      var max = _this.state.max;
      _this.setState({
        min: max === null ? value : value > max ? max - 1 : value
      });
    });
    (0, _defineProperty2.default)(_this, "setMin", function (e) {
      e.preventDefault();
      _this.setState({
        min: findMin(_this.props.data, _this.props.dataIndex)
      });
    });
    (0, _defineProperty2.default)(_this, "setMax", function (e) {
      e.preventDefault();
      _this.setState({
        max: findMax(_this.props.data, _this.props.dataIndex)
      });
    });
    (0, _defineProperty2.default)(_this, "onMaxChange", function (value) {
      var min = _this.state.min;
      _this.setState({
        max: min === null ? value : value < min ? min + 1 : value
      });
    });
    var selectedKeys = props.selectedKeys;
    var _min = selectedKeys[0] ? selectedKeys[0].min : null;
    var _max = selectedKeys[0] ? selectedKeys[0].max : null;
    _this.state = {
      min: _min,
      max: _max
    };
    return _this;
  }
  (0, _inherits2.default)(NumberFilter, _Component);
  return (0, _createClass2.default)(NumberFilter, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        setSelectedKeys = _this$props.setSelectedKeys,
        _confirm = _this$props.confirm,
        _clearFilters = _this$props.clearFilters,
        locale = _this$props.locale;
      var _this$state = this.state,
        min = _this$state.min,
        max = _this$state.max;
      return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: "dropdown-container"
      }, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement(_Button.default, {
        link: "#",
        onClick: this.setMin
      }, "Minimum")), /*#__PURE__*/_react.default.createElement(_NumberInput.default, {
        size: "small",
        value: min,
        onChange: this.onMinChange
      }), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement(_Button.default, {
        link: "#",
        onClick: this.setMax
      }, "Maximum")), /*#__PURE__*/_react.default.createElement(_NumberInput.default, {
        size: "small",
        value: max,
        onChange: this.onMaxChange
      }), /*#__PURE__*/_react.default.createElement("p", null, " ")), /*#__PURE__*/_react.default.createElement(_FooterFilter.default, {
        locale: locale,
        confirm: function confirm() {
          setSelectedKeys([{
            min: _this2.state.min,
            max: _this2.state.max
          }]);
          setTimeout(function () {
            _confirm();
          }, 0);
        },
        clearFilters: function clearFilters() {
          _this2.setState({
            min: null,
            max: null
          }, function () {
            setSelectedKeys([]);
            setTimeout(function () {
              _clearFilters();
            }, 0);
          });
        }
      }));
    }
  }]);
}(_react.Component);
/**
 *
 * @param {string} dataIndex
 * @param {object|string} value
 * @param {object} record
 */
(0, _defineProperty2.default)(NumberFilter, "defaultProps", {
  dropdownPrefixCls: 'ykb-dropdown'
});
var onNumberFilter = exports.onNumberFilter = function onNumberFilter(dataIndex, value, record) {
  if (!value) return false;
  var number = record[dataIndex];
  if (number === null || number === undefined) return false;

  // is js Date
  if (typeof number === 'string') {
    number = parseInt(number.replace(/\./g, '').replace(',', '.'));
  }

  // this means we are deailing with first date
  if (value.min && value.max) {
    return value.min <= number && value.max >= number;
  } else if (value.min) {
    return value.min <= number;
  } else if (value.max) {
    return value.max >= number;
  }
  return false;
};